import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Action } from '../../../../Typography/index.js';
import { FlexContainer, FlexItem } from '../../../../CSS/index.js';
const LINKS = Object.freeze({
    PRIVACY_POLICY: 'https://www.astrumu.com/privacy-policy',
    TERMS_OF_SERVICE: 'https://www.astrumu.com/terms-of-service'
});
const Navigation = ({ ignoreCSSClass }) => (_jsx("nav", { css: css({ paddingTop: 10 }), className: ignoreCSSClass, children: _jsxs(FlexContainer, { as: "ul", "aria-label": "legal links", style: {
            gap: 20,
            justifyContent: 'flex-end',
            flexDirection: 'column',
            alignItems: 'flex-end',
            '@media (min-width: 768px)': {
                flexDirection: 'row'
            }
        }, children: [_jsx(FlexItem, { as: "li", "aria-label": "terms of service", style: theme => ({
                    padding: '0 5px',
                    '& a span': {
                        transition: 'all .2s ease',
                        '&:hover': {
                            color: theme.primaryAccentColor
                        }
                    }
                }), children: _jsx("a", { target: "_blank", "data-cy": "terms-of-service", rel: "noopener noreferrer", href: LINKS.TERMS_OF_SERVICE, children: _jsx(Action, { element: "span", children: "Terms of Service" }) }) }), _jsx(FlexItem, { as: "li", style: theme => ({
                    padding: '0 5px',
                    '& a span': {
                        transition: 'all .2s ease',
                        '&:hover': {
                            color: theme.primaryAccentColor
                        }
                    }
                }), "aria-label": "privacy policy", children: _jsx("a", { target: "_blank", "data-cy": "privacy-policy", rel: "noopener noreferrer", href: LINKS.PRIVACY_POLICY, children: _jsx(Action, { element: "span", children: "Privacy Policy" }) }) })] }) }));
export default Navigation;
//# sourceMappingURL=index.js.map